/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/system';
import { getFunctions, httpsCallable } from "firebase/functions";
import ContentCard from '../../../ui-elements/cards/ContentCard';
import { BsGridFill } from "react-icons/bs";
import { FaBell } from "react-icons/fa";

import { BsFillPeopleFill } from "react-icons/bs";
import Badge from '@mui/material/Badge';
const DashboardPage = () => {
    const [userCount, setUserCount] = useState(0);
    const [postsCount, setPostsCount] = useState(0);
    const [reportedPostsCount, setReportedPostsCount] = useState(0);
    const [reportedUsersCount, setReportedUsersCount] = useState(0);

    const getAllCount = async () => {
        const functions = getFunctions();

        const callableReturnMessage = httpsCallable(functions, 'getAllCounts');

        callableReturnMessage().then((result) => {
            setUserCount(result.data.userCount);
            setPostsCount(result.data.postsCount);
            setReportedPostsCount(result.data.postReportsCount);
            setReportedUsersCount(result.data.userReportsCount)
        }).catch((error) => {
            console.log(error);
        });

    };

    useEffect(() => {
        getAllCount();
    }, []);
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={3} md={3}>
                        <ContentCard link="/manage-users" title="Users" subTitle="Manage Users" icon={<Badge badgeContent={userCount} color="secondary">
                            <BsFillPeopleFill />
                        </Badge>}>
                        </ContentCard>


                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                        <ContentCard link="/manage-posts" title="Posts" subTitle="Manage Posts" icon={<Badge badgeContent={postsCount} color="secondary">
                            <BsGridFill />
                        </Badge>}>

                        </ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                        <ContentCard link="/manage-reported-users" title="Reported Users" subTitle="Manage Reported Users" icon={<Badge badgeContent={reportedUsersCount ?? 0} color="secondary">
                            <BsFillPeopleFill />
                        </Badge>}>
                        </ContentCard>

                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                        <ContentCard link="/manage-reported-posts" title="Reported Posts" subTitle="Manage Reported Posts" icon={<Badge badgeContent={reportedPostsCount ?? 0} color="secondary">
                            <BsGridFill />
                        </Badge>}>
                        </ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                        <ContentCard link="/manage-notifications" title="Notifications" subTitle="Manage Notifications" icon={<FaBell />}>
                        </ContentCard>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}

export default DashboardPage;